import { cdnImageUrl, cdnUrl, type CdnResizeOptions } from '@platform/media';

/**
 * 문서 에셋 주소 조립.
 *
 * 두 가지 출처를 모두 받는다:
 *  1. **절대 URL** — 대표님이 에디터에서 올린 파일. media-service 가 S3 에 넣고
 *     CDN URL 을 그대로 돌려준다. 이미 완성된 주소라 손대지 않는다.
 *  2. **상대 키** — CI 가 CDN 의 `docs/` 아래로 동기화한 파일. prefix 를 붙인다.
 *
 * 둘을 구분하지 않으면 업로드한 이미지에 `docs/` 가 덧붙어 전부 404 가 된다.
 */
const DOCS_PREFIX = 'docs';

const isAbsolute = (src: string): boolean => /^https?:\/\//i.test(src);

export const docsAssetUrl = (key: string): string =>
  isAbsolute(key) ? key : cdnUrl(`${DOCS_PREFIX}/${key}`);

export const docsImageUrl = (key: string, opts?: CdnResizeOptions): string =>
  isAbsolute(key) ? key : cdnImageUrl(`${DOCS_PREFIX}/${key}`, opts);
